export default {
  name: "The J.Whitney Group",
  dates: "May 2016 – Jul 2020",
  title: "Co-founder and Chief Technology Officer",
  technologies: "Excel VBA, Windows Server 2016",
  bullets: [
    "Led clients through competitive state cannabis business licensing competitions by designing detailed 3-5 year business plans with financial projections, compliant Standard Operating Procedures, security plans, marketing plans, community service plans, and facility layout and operations planning.",
    "Spearheaded effort to win a client 3 dispensary licenses in the Las Vegas area, valued at $30M.",
    "Developed Excel VBA programs to automate data collection, analysis, and reporting, enhancing accuracy.",
    "Revamped operational systems for clients struggling to get their licensed facilities operational, ensuring compliance, passing regulatory inspections, and enabling client to begin generating revenues.",
  ],
};
